(() => {
  if (window.nlSignPersonalisationReady) return;
  window.nlSignPersonalisationReady = true;
  document.addEventListener('input', (event) => {
    if (!event.target.matches('[data-nl-personalisation]')) return;
    event.target.setCustomValidity('');
    event.target.removeAttribute('aria-invalid');
  });
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const fields = Array.from(form.elements).filter((element) => element.matches('[data-nl-personalisation]'));
    let firstInvalid;
    fields.forEach((field) => {
      field.setCustomValidity(field.value.trim() ? '' : 'Please fill in this detail for your sign.');
      if (!field.checkValidity()) {
        field.setAttribute('aria-invalid', 'true');
        firstInvalid ||= field;
      } else field.removeAttribute('aria-invalid');
    });
    if (firstInvalid) {
      event.preventDefault();
      event.stopImmediatePropagation();
      firstInvalid.focus();
      firstInvalid.reportValidity();
    }
  }, true);
})();
